// components/skins/dashboard-schematics.js
export class DashboardSchematics {
  schematicsskin() {
    return `

      <div class="container-layout full-height">
        <div class="container-column">
          <div class="column-header schematic-topbar" style="padding:12px 16px;">
            <div class="header-title has-icon">
              <h3>Schematics</h3>
            </div>
            <div class="header-actions">
              <button id="upload-svg-btn" class="btn btn-primary">Upload SVG</button>
              <input type="file" id="upload-svg-input" accept=".svg" style="display:none"/>
              <!-- optional: schematics selector -->
              <select id="schematic-select"></select>
            </div>
          </div>

          <div class="container-body" style="display:flex; height: calc(100vh - 60px); position:relative;">
            <!-- Main canvas -->
            <div class="schematics-canvas" style="flex:1; position:relative;" id="schematics-canvas"></div>

            <!-- Node editor (superadmin only) -->
            <div id="schematic-node-editor" class="node-editor hidden" aria-hidden="true">
              <h4>Node Editor</h4>

              <label>Label</label>
              <input type="text" id="node-label"/>

              <label>Tag (semantic)</label>
              <input type="text" id="node-tag" placeholder="e.g. pv_active_power"/>

              <label>Type</label>
              <select id="node-type">
                <option value="text">Text</option>
                <option value="pv">PV</option>
                <option value="bess">BESS</option>
                <option value="indicator">Indicator</option>
                <option value="line">Line</option>
                <option value="other">Other</option>
              </select>

              <label>Map to register (optional)</label>
              <select id="node-register-select">
                <option value="">-- none --</option>
              </select>

              <label><input type="checkbox" id="node-update-text"> Update text</label>
              <label><input type="checkbox" id="node-update-color"> Update color</label>

              <div style="margin-top:8px;">
                <label>High threshold</label>
                <input type="number" id="node-th-high" placeholder="High"/>
                <label>Low threshold</label>
                <input type="number" id="node-th-low" placeholder="Low"/>
              </div>

              <div style="margin-top:12px;display:flex;gap:8px;">
                <button id="save-node-btn" class="btn btn-primary">Save</button>
                <button id="close-node-btn" class="btn">Close</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    `;
  }
}
